import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, withCtx as _withCtx, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/sntyp.gif'


const _hoisted_1 = { id: "main-content" }
const _hoisted_2 = { id: "first-splash-row" }
const _hoisted_3 = { id: "splash-screen-acknowledgements" }
const _hoisted_4 = { id: "splash-screen-icons" }
const _hoisted_5 = {
  class: "modal",
  id: "modal-loading"
}
const _hoisted_6 = { class: "top-content" }
const _hoisted_7 = { id: "center-buttons" }
const _hoisted_8 = { id: "left-buttons" }
const _hoisted_9 = { class: "right-content" }
const _hoisted_10 = { class: "bottom-content" }
const _hoisted_11 = { id: "tools" }
const _hoisted_12 = { id: "button-text" }
const _hoisted_13 = { id: "chart-container" }
const _hoisted_14 = { class: "tool-container" }
const _hoisted_15 = { class: "opacity-slider-wrapper" }
const _hoisted_16 = { class: "video-wrapper" }
const _hoisted_17 = { class: "text-center red--text" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "credits" }
const _hoisted_20 = { style: {"min-height":"120px"} }
const _hoisted_21 = { class: "text-list" }
const _hoisted_22 = {
  id: "user-experience-footer",
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorldWideTelescope = _resolveComponent("WorldWideTelescope")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_story_credits = _resolveComponent("story-credits")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_icon_button = _resolveComponent("icon-button")!
  const _component_gallery = _resolveComponent("gallery")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_chartjs_scatter = _resolveComponent("chartjs-scatter")!
  const _component_vue_slider = _resolveComponent("vue-slider")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_funding_acknowledgment = _resolveComponent("funding-acknowledgment")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_user_experience = _resolveComponent("user-experience")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_cds_privacy_policy = _resolveComponent("cds-privacy-policy")!
  const _component_notifications = _resolveComponent("notifications")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    id: "app",
    style: _normalizeStyle(_ctx.cssVars)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_WorldWideTelescope, {
          "wwt-namespace": _ctx.wwtNamespace,
          class: _normalizeClass({ pointer: _ctx.lastClosePt !== null }),
          onPointermove: _ctx.onPointerMove,
          onPointerup: _ctx.onPointerUp,
          onPointerdown: _ctx.onPointerDown
        }, null, 8, ["wwt-namespace", "class", "onPointermove", "onPointerup", "onPointerdown"]),
        _createVNode(_component_v_overlay, {
          "model-value": _ctx.showSplashScreen,
          absolute: "",
          opacity: "0.6",
          style: _normalizeStyle(_ctx.cssVars),
          id: "splash-overlay"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              id: "splash-screen",
              style: _normalizeStyle(_ctx.cssVars)
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  id: "close-splash-button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeSplashScreen && _ctx.closeSplashScreen(...args)))
                }, "×"),
                _cache[29] || (_cache[29] = _createElementVNode("div", { id: "splash-screen-text" }, [
                  _createElementVNode("p", null, " See a "),
                  _createElementVNode("p", { class: "highlight" }, " Star Explode "),
                  _createElementVNode("p", { class: "small" }, " in a galaxy far, far away... ")
                ], -1))
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_v_btn, {
                  class: "splash-get-started",
                  onClick: _ctx.closeSplashScreen,
                  onKeyup: _withKeys(_ctx.closeSplashScreen, ["enter"]),
                  color: _ctx.cssVars['--accent-color'],
                  variant: "elevated",
                  rounded: "lg"
                }, {
                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                    _createTextVNode(" Get Started ")
                  ])),
                  _: 1,
                  __: [30]
                }, 8, ["onClick", "onKeyup", "color"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _cache[31] || (_cache[31] = _createTextVNode(" Brought to you by ")),
                _cache[32] || (_cache[32] = _createElementVNode("a", {
                  href: "https://www.cosmicds.cfa.harvard.edu/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "Cosmic Data Stories", -1)),
                _cache[33] || (_cache[33] = _createTextVNode(" and ")),
                _cache[34] || (_cache[34] = _createElementVNode("a", {
                  href: "https://www.worldwidetelescope.org/home/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "WorldWide Telescope", -1)),
                _cache[35] || (_cache[35] = _createTextVNode(". ")),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_story_credits)
                ])
              ])
            ], 4)
          ]),
          _: 1
        }, 8, ["model-value", "style"]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_5, _cache[36] || (_cache[36] = [
              _createElementVNode("div", { class: "container" }, [
                _createElementVNode("div", { class: "spinner" }),
                _createElementVNode("p", null, "Loading …")
              ], -1)
            ]), 512), [
              [_vShow, _ctx.isLoading]
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            false
              ? (_openBlock(), _createBlock(_component_icon_button, {
                  key: 0,
                  modelValue: _ctx.showLocationSelector,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showLocationSelector) = $event)),
                  "fa-icon": "location-pin",
                  color: _ctx.accentColor,
                  focus: _ctx.accentColor2,
                  "tooltip-text": "Select location",
                  "tooltip-location": "bottom"
                }, null, 8, ["modelValue", "color", "focus"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_icon_button, {
              modelValue: _ctx.showTextSheet,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showTextSheet) = $event)),
              "fa-icon": "book-open",
              color: _ctx.accentColor,
              "tooltip-text": _ctx.showTextSheet ? 'Hide Info' : 'Learn More',
              "tooltip-location": "start"
            }, null, 8, ["modelValue", "color", "tooltip-text"]),
            _createVNode(_component_icon_button, {
              modelValue: _ctx.showVideoSheet,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showVideoSheet) = $event)),
              "fa-icon": "video",
              color: _ctx.accentColor,
              "tooltip-text": "Watch video",
              "tooltip-location": "start"
            }, null, 8, ["modelValue", "color"]),
            _createVNode(_component_icon_button, {
              onActivate: _ctx.centerView,
              "fa-icon": "refresh",
              color: _ctx.accentColor,
              "tooltip-text": "Center the Pinwheel",
              "tooltip-location": "start"
            }, null, 8, ["onActivate", "color"]),
            _createVNode(_component_icon_button, {
              modelValue: _ctx.showConstellations,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showConstellations) = $event)),
              color: _ctx.accentColor,
              "fa-icon": "constellation",
              "tooltip-text": _ctx.showConstellations ? 'Hide constellations' : 'Show constellations',
              "tooltip-location": "start"
            }, null, 8, ["modelValue", "color", "tooltip-text"]),
            _createVNode(_component_icon_button, {
              modelValue: _ctx.showArrow,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showArrow) = $event)),
              color: _ctx.accentColor,
              "fa-icon": "arrow-right",
              "tooltip-text": _ctx.showArrow ? 'Hide the arrow' : 'Show the arrow',
              "tooltip-location": "start"
            }, null, 8, ["modelValue", "color", "tooltip-text"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_gallery, {
            "wtml-url": "https://raw.githubusercontent.com/johnarban/wwt_interactives/main/images/m101/gallery.wtml",
            width: "1000px",
            "single-select": true,
            title: "Click Image to Overlay",
            "closed-text": "Image Gallery",
            "selected-color": _ctx.accentColor,
            style: _normalizeStyle(_ctx.cssVars),
            "preview-index": 1,
            onSelect: _ctx.onItemSelected,
            onDeselect: _ctx.onItemDeselected
          }, null, 8, ["selected-color", "style", "onSelect", "onDeselect"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              id: "chart-button",
              class: _normalizeClass([_ctx.chartVisible ? 'collapse-button': ''])
            }, [
              _createVNode(_component_v_btn, {
                flat: "",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.chartVisible = !_ctx.chartVisible)),
                onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.chartVisible = !_ctx.chartVisible), ["enter"])),
                color: _ctx.accentColor
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, {
                    id: "chart-icon",
                    class: "control-icon",
                    icon: _ctx.chartVisible ? 'circle-xmark' : 'chart-line',
                    size: "xl"
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.chartVisible ? 'Hide' : 'Show') + " supernova brightness graph", 1)
                ]),
                _: 1
              }, 8, ["color"])
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_13, [
              _cache[37] || (_cache[37] = _createElementVNode("div", { id: "chart-title" }, " Supernova Light Curve (Change in Brightness Over Time) ", -1)),
              _cache[38] || (_cache[38] = _createElementVNode("div", { id: "yaxis-text" }, [
                _createTextVNode(" Supernova "),
                _createElementVNode("br"),
                _createTextVNode(" Brightness ")
              ], -1)),
              _createVNode(_component_chartjs_scatter, {
                reversedY: "",
                scatter: "",
                line: "",
                animation: false,
                data: _ctx.lightCurveData.filter(d => (d.time.getTime() <= _ctx.selectedTime )),
                lineData: _ctx.lightCurveData.filter(d => (d.time.getTime() <= _ctx.selectedTime )),
                keys: { x: 'time', y: 'magnitude' },
                xrange: [Math.min(..._ctx.dates.map(d => d)), Math.max(..._ctx.dates.map(d => d))],
                yrange: [10.5, 17],
                color: _ctx.accentColor2,
                borderColor: _ctx.accentColor2,
                scatterOptions: {radius: 5, borderWidth: 2},
                lineOptions: {borderColor: 'white', borderWidth: 1.5},
                yAxisOptions: {
              title: { display: false,
                text: 'Supernova Brightness',
                color: 'white',
                },
              border: { display: true,
                color: 'white',
                width: 4,
              },
              ticks: {display: false},
              },
                xAxisOptions: {
                border: { display: true,
                  color: 'white',
                  width: 4,
                },
                title: {display: false},
                ticks: {display: false},
              },
                onBounds: _cache[8] || (_cache[8] = (val) => { _ctx.chartBounds = val; _ctx.onResize() })
              }, null, 8, ["data", "lineData", "xrange", "color", "borderColor"]),
              _cache[39] || (_cache[39] = _createElementVNode("div", { id: "xaxis-text" }, " Time ", -1))
            ], 512), [
              [_vShow, _ctx.chartVisible]
            ]),
            _createElementVNode("span", _hoisted_14, [
              _createVNode(_component_icon_button, {
                class: "play-pause-icon-wrapper",
                "tooltip-location": "top",
                color: _ctx.accentColor,
                "focus-color": _ctx.accentColor,
                "tooltip-text": "Watch the supernova change over time!",
                onActivate: _cache[9] || (_cache[9] = () => {
                  _ctx.playing = !(_ctx.playing || _ctx.playingImagePath); // set playing to true if both playing & pCP are false. set playing to false if either playing or pCP are true.
                  _ctx.playingImagePath = false; // don't reverse the order of this line and previous or logic will break.
                })
              }, {
                button: _withCtx(() => [
                  _cache[40] || (_cache[40] = _createElementVNode("span", { class: "play-icon-text" }, "Watch over time ", -1)),
                  _createVNode(_component_font_awesome_icon, {
                    id: "play-pause-icon",
                    class: "control-icon",
                    icon: !(_ctx.playing || _ctx.playingImagePath) ? 'play' : 'pause',
                    size: "sm"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["color", "focus-color"]),
              _createVNode(_component_vue_slider, {
                adsorb: "",
                included: "",
                duration: 0.1,
                id: "slider",
                marks: (d) => {
              return _ctx.allDates.includes(d) || _ctx.imageDates.includes(d);
            },
                order: false,
                modelValue: _ctx.selectedTime,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedTime) = $event)),
                onChange: _ctx.onTimeSliderChange,
                data: _ctx.dates,
                tooltip: "always",
                "tooltip-placement": "bottom",
                "tooltip-style": {opacity: 0.75},
                "tooltip-formatter": (v) => 
              _ctx.toDateString(new Date(v))
            
              }, {
                mark: _withCtx(({ pos, value }) => [
                  _createElementVNode("div", {
                    class: _normalizeClass([{ 'mark-line': _ctx.imageDates.includes(value) }]),
                    style: _normalizeStyle({ left: `${pos}%` })
                  }, null, 6)
                ]),
                _: 1
              }, 8, ["marks", "modelValue", "onChange", "data", "tooltip-formatter"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            (!_ctx.smallSize)
              ? (_openBlock(), _createBlock(_component_vue_slider, {
                  key: 0,
                  class: "opacity-slider",
                  adsorb: "",
                  min: 0,
                  max: 1,
                  interval: 0.01,
                  id: "opacity-slider",
                  order: false,
                  tooltipPlacement: "bottom",
                  modelValue: _ctx.currentOpacity,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.currentOpacity) = $event)),
                  onChange: _cache[12] || (_cache[12] = (opacity) => _ctx.currentLayer?.set_opacity(opacity))
                }, {
                  default: _withCtx(() => _cache[41] || (_cache[41] = [
                    _createElementVNode("span", null, "Change image opacity", -1)
                  ])),
                  _: 1,
                  __: [41]
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.smallSize)
            ? (_openBlock(), _createBlock(_component_story_credits, {
                key: 0,
                class: "bottom-credits"
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_v_dialog, {
          id: "video-container",
          modelValue: _ctx.showVideoSheet,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.showVideoSheet) = $event)),
          transition: "slide-y-transition",
          fullscreen: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_font_awesome_icon, {
                id: "video-close-icon",
                class: "close-icon",
                icon: "times",
                size: "lg",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showVideoSheet = false)),
                onKeyup: _cache[14] || (_cache[14] = _withKeys(($event: any) => (_ctx.showVideoSheet = false), ["enter"])),
                tabindex: "0"
              }),
              _cache[42] || (_cache[42] = _createElementVNode("iframe", {
                height: "700",
                id: "info-video",
                src: "https://www.youtube.com/embed/CY2XMeY8w3w?&autoplay=1",
                title: "YouTube video player",
                frameborder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                allowfullscreen: ""
              }, null, -1))
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          id: "location-dialog",
          modelValue: _ctx.showLocationSelector,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.showLocationSelector) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { id: "location-selector" }, {
              default: _withCtx(() => [
                _cache[44] || (_cache[44] = _createElementVNode("div", { class: "text-center" }, " Move around the map and double-click to change location ", -1)),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.getLocation,
                  onKeyup: _withKeys(_ctx.getLocation, ["enter"])
                }, {
                  default: _withCtx(() => _cache[43] || (_cache[43] = [
                    _createTextVNode(" Use My Location ")
                  ])),
                  _: 1,
                  __: [43]
                }, 8, ["onClick", "onKeyup"]),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.locationErrorMessage), 1),
                _cache[45] || (_cache[45] = _createElementVNode("div", { id: "map-container" }, null, -1))
              ]),
              _: 1,
              __: [44,45]
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          style: _normalizeStyle(_ctx.cssVars),
          class: "bottom-sheet",
          id: "text-bottom-sheet",
          "hide-overlay": "",
          persistent: "",
          "no-click-animation": "",
          absolute: "",
          width: "100%",
          scrim: false,
          location: "bottom",
          modelValue: _ctx.showTextSheet,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.showTextSheet) = $event)),
          transition: "dialog-bottom-transition"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { height: "100%" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs, {
                  modelValue: _ctx.tab,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.tab) = $event)),
                  height: "32px",
                  color: _ctx.accentColor,
                  "slider-color": _ctx.accentColor,
                  id: "tabs",
                  dense: "",
                  grow: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tab, { tabindex: "0" }, {
                      default: _withCtx(() => _cache[46] || (_cache[46] = [
                        _createElementVNode("h3", null, "Information", -1)
                      ])),
                      _: 1,
                      __: [46]
                    }),
                    _createVNode(_component_v_tab, { tabindex: "0" }, {
                      default: _withCtx(() => _cache[47] || (_cache[47] = [
                        _createElementVNode("h3", null, "Using WWT", -1)
                      ])),
                      _: 1,
                      __: [47]
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "color", "slider-color"]),
                _createVNode(_component_font_awesome_icon, {
                  id: "close-text-icon",
                  class: "control-icon",
                  icon: "times",
                  size: "lg",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showTextSheet = false)),
                  onKeyup: _cache[19] || (_cache[19] = _withKeys(($event: any) => (_ctx.showTextSheet = false), ["enter"])),
                  tabindex: "0"
                }),
                _createVNode(_component_v_window, {
                  modelValue: _ctx.tab,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.tab) = $event)),
                  id: "tab-items",
                  class: "pb-2 no-bottom-border-radius"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "no-bottom-border-radius scrollable" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "info-text no-bottom-border-radius" }, {
                              default: _withCtx(() => [
                                _cache[81] || (_cache[81] = _createElementVNode("h3", null, [
                                  _createElementVNode("i", null, "Something new has burst onto the scene in the Pinwheel Galaxy!")
                                ], -1)),
                                _cache[82] || (_cache[82] = _createElementVNode("p", null, [
                                  _createTextVNode(" On May 19, 2023 - renowned supernova hunter "),
                                  _createElementVNode("a", {
                                    href: "https://www.scientificamerican.com/article/astronomers-have-spotted-a-once-in-a-decade-supernova-and-you-can-too/",
                                    target: "_blank",
                                    rel: "noopener noreferrer"
                                  }, "Koichi Itagaki discovered"),
                                  _createTextVNode(" a new bright object in the very nearby Pinwheel Galaxy (also known as M101). This bright object was a "),
                                  _createElementVNode("strong", null, "new supernova"),
                                  _createTextVNode(". ")
                                ], -1)),
                                _cache[83] || (_cache[83] = _createElementVNode("br", null, null, -1)),
                                _cache[84] || (_cache[84] = _createElementVNode("h3", null, "What is a Supernova?", -1)),
                                _cache[85] || (_cache[85] = _createElementVNode("p", null, [
                                  _createTextVNode(" A "),
                                  _createElementVNode("strong", null, "supernova"),
                                  _createTextVNode(" is an extremely bright, energetic explosion of a star. They are so bright that you can see when they occur in galaxies millions of light years away. ")
                                ], -1)),
                                _cache[86] || (_cache[86] = _createElementVNode("p", null, " There are two situations which trigger a supernova— a very large star (8+ times our Sun's mass) runs out of fuel and then blows up; or a white dwarf (the remnants of stars like our Sun) pulls enough extra gas onto itself from a companion star that it blows up. ", -1)),
                                _cache[87] || (_cache[87] = _createElementVNode("p", null, [
                                  _createTextVNode(" The first type of supernova is called a "),
                                  _createElementVNode("a", {
                                    href: "https://astronomy.swin.edu.au/cosmos/c/core-collapse",
                                    target: "_blank",
                                    rel: "noopener noreferrer"
                                  }, "core-collapse supernova"),
                                  _createTextVNode(" (Type II) and can teach us about the evolution and environment of massive stars. The second type ("),
                                  _createElementVNode("a", {
                                    href: "https://astronomy.swin.edu.au/cosmos/T/Type+Ia+Supernova",
                                    target: "_blank",
                                    rel: "noopener noreferrer"
                                  }, "Type Ia"),
                                  _createTextVNode(") have predictable brightness and are used to measure the cosmological expansion of the universe. ")
                                ], -1)),
                                _cache[88] || (_cache[88] = _createElementVNode("h3", null, "The Brightness Graph", -1)),
                                _cache[89] || (_cache[89] = _createElementVNode("p", null, [
                                  _createTextVNode(" Astronomers graph how a supernova's brightness changes over time (called a "),
                                  _createElementVNode("strong", null, "lightcurve"),
                                  _createTextVNode(") to distinguish between the two main types of supernovae. Type II are characterized by a rapid rise followed by a plateau and or gradual dimming. Type I have a rapid rise followed by a more rapid dimming. ")
                                ], -1)),
                                _cache[90] || (_cache[90] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
                                _cache[91] || (_cache[91] = _createElementVNode("p", null, [
                                  _createTextVNode(" You can learn about other types of supernovae "),
                                  _createElementVNode("a", {
                                    href: "https://astrobites.org/2016/12/02/classifying-supernovae/",
                                    target: "_blank",
                                    rel: "noopener noreferrer"
                                  }, "here"),
                                  _createTextVNode(". ")
                                ], -1)),
                                _cache[92] || (_cache[92] = _createElementVNode("strong", null, "What type of supernova do you think the one in the Pinwheel Galaxy is?", -1)),
                                _cache[93] || (_cache[93] = _createElementVNode("br", null, null, -1)),
                                (!_ctx.revealAnswer)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      style: {"max-width":"fit-content","margin-block":"1em"},
                                      class: "control-icon-wrapper",
                                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.revealAnswer = true))
                                    }, " Click to reveal the answer "))
                                  : _createCommentVNode("", true),
                                _cache[94] || (_cache[94] = _createElementVNode("br", null, null, -1)),
                                (_ctx.revealAnswer)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, " With the rapid rise and long plateau this looks most similar to a Type II supernova. "))
                                  : _createCommentVNode("", true),
                                _cache[95] || (_cache[95] = _createElementVNode("br", null, null, -1)),
                                _cache[96] || (_cache[96] = _createElementVNode("br", null, null, -1)),
                                _cache[97] || (_cache[97] = _createElementVNode("br", null, null, -1)),
                                _createElementVNode("div", _hoisted_19, [
                                  _cache[48] || (_cache[48] = _createElementVNode("h3", null, "Credits:", -1)),
                                  _cache[49] || (_cache[49] = _createElementVNode("h4", null, " MicroObservatory:", -1)),
                                  _cache[50] || (_cache[50] = _createElementVNode("p", null, [
                                    _createTextVNode(" The images shown in the \"Watch over time\" sequence were taken with "),
                                    _createElementVNode("a", {
                                      href: "https://mo-www.cfa.harvard.edu/MicroObservatory/",
                                      target: "_blank",
                                      rel: "noopener noreferrer"
                                    }, "MicroObservatory"),
                                    _createTextVNode(". We use them here because they observe the Pinwheel Galaxy every night in a consistent way. (Dates without MicroObservatory images had bad weather). ")
                                  ], -1)),
                                  _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1)),
                                  _cache[52] || (_cache[52] = _createElementVNode("h4", null, " MicroObservatory Images and Data Processing:", -1)),
                                  _cache[53] || (_cache[53] = _createElementVNode("p", null, [
                                    _createTextVNode("Martin Fowler ("),
                                    _createElementVNode("a", {
                                      href: "https://solarsystem.nasa.gov/people/647/martin-fowler/",
                                      target: "_blank",
                                      rel: "noopener noreferrer"
                                    }, "NASA Citizen Scientist"),
                                    _createTextVNode(")")
                                  ], -1)),
                                  _cache[54] || (_cache[54] = _createElementVNode("br", null, null, -1)),
                                  _cache[55] || (_cache[55] = _createElementVNode("h4", null, [
                                    _createElementVNode("a", {
                                      href: "https://www.cosmicds.cfa.harvard.edu/",
                                      target: "_blank",
                                      rel: "noopener noreferrer"
                                    }, "CosmicDS"),
                                    _createTextVNode(" Team:")
                                  ], -1)),
                                  _cache[56] || (_cache[56] = _createTextVNode(" John Lewis")),
                                  _cache[57] || (_cache[57] = _createElementVNode("br", null, null, -1)),
                                  _cache[58] || (_cache[58] = _createTextVNode(" Jon Carifio")),
                                  _cache[59] || (_cache[59] = _createElementVNode("br", null, null, -1)),
                                  _cache[60] || (_cache[60] = _createTextVNode(" Pat Udomprasert")),
                                  _cache[61] || (_cache[61] = _createElementVNode("br", null, null, -1)),
                                  _cache[62] || (_cache[62] = _createTextVNode(" Alyssa Goodman")),
                                  _cache[63] || (_cache[63] = _createElementVNode("br", null, null, -1)),
                                  _cache[64] || (_cache[64] = _createTextVNode(" Mary Dussault")),
                                  _cache[65] || (_cache[65] = _createElementVNode("br", null, null, -1)),
                                  _cache[66] || (_cache[66] = _createTextVNode(" Harry Houghton")),
                                  _cache[67] || (_cache[67] = _createElementVNode("br", null, null, -1)),
                                  _cache[68] || (_cache[68] = _createTextVNode(" Anna Nolin")),
                                  _cache[69] || (_cache[69] = _createElementVNode("br", null, null, -1)),
                                  _cache[70] || (_cache[70] = _createTextVNode(" Evaluator: Sue Sunbury")),
                                  _cache[71] || (_cache[71] = _createElementVNode("br", null, null, -1)),
                                  _cache[72] || (_cache[72] = _createElementVNode("br", null, null, -1)),
                                  _cache[73] || (_cache[73] = _createElementVNode("h4", null, "WorldWide Telescope Team:", -1)),
                                  _cache[74] || (_cache[74] = _createTextVNode(" Peter Williams")),
                                  _cache[75] || (_cache[75] = _createElementVNode("br", null, null, -1)),
                                  _cache[76] || (_cache[76] = _createTextVNode(" A. David Weigel")),
                                  _cache[77] || (_cache[77] = _createElementVNode("br", null, null, -1)),
                                  _cache[78] || (_cache[78] = _createTextVNode(" Jon Carifio")),
                                  _cache[79] || (_cache[79] = _createElementVNode("br", null, null, -1)),
                                  _cache[80] || (_cache[80] = _createElementVNode("br", null, null, -1)),
                                  _createVNode(_component_funding_acknowledgment)
                                ]),
                                _createVNode(_component_v_spacer, { class: "end-spacer" })
                              ]),
                              _: 1,
                              __: [81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97]
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: "no-bottom-border-radius scrollable",
                          style: {"height":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "info-text no-bottom-border-radius" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_container, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { align: "center" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "4" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_chip, {
                                              label: "",
                                              outlined: ""
                                            }, {
                                              default: _withCtx(() => _cache[98] || (_cache[98] = [
                                                _createTextVNode(" Pan ")
                                              ])),
                                              _: 1,
                                              __: [98]
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "8",
                                          class: "pt-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "press + drag" : "click + drag"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? ":" : "or") + " ", 1),
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? ":" : "W-A-S-D"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? ":" : "keys"), 1),
                                            _cache[99] || (_cache[99] = _createElementVNode("br", null, null, -1))
                                          ]),
                                          _: 1,
                                          __: [99]
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, { align: "center" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "4" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_chip, {
                                              label: "",
                                              outlined: ""
                                            }, {
                                              default: _withCtx(() => _cache[100] || (_cache[100] = [
                                                _createTextVNode(" Zoom ")
                                              ])),
                                              _: 1,
                                              __: [100]
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "8",
                                          class: "pt-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "pinch in and out" : "scroll in and out"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? ":" : "or") + " ", 1),
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? ":" : "I-O"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? ":" : "keys"), 1),
                                            _cache[101] || (_cache[101] = _createElementVNode("br", null, null, -1))
                                          ]),
                                          _: 1,
                                          __: [101]
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_20, [
                                              _cache[110] || (_cache[110] = _createElementVNode("h4", null, "Tips:", -1)),
                                              _createElementVNode("ul", _hoisted_21, [
                                                _createElementVNode("li", null, [
                                                  _cache[102] || (_cache[102] = _createTextVNode(" Click ")),
                                                  _createVNode(_component_font_awesome_icon, {
                                                    id: "play-pause-icon",
                                                    class: "control-icon",
                                                    icon: "play",
                                                    size: "lg"
                                                  }),
                                                  _cache[103] || (_cache[103] = _createTextVNode(" to watch the supernova brightness change over time. "))
                                                ]),
                                                _cache[104] || (_cache[104] = _createElementVNode("li", null, " Adjust the date slider at the bottom to move to a specific time. ", -1)),
                                                _cache[105] || (_cache[105] = _createElementVNode("li", null, " Click \"Show supernova brightness graph\" to see how its brightness changes with time. ", -1)),
                                                _cache[106] || (_cache[106] = _createElementVNode("li", null, " Click the Image Gallery to see higher resolution images of the galaxy. ", -1)),
                                                _cache[107] || (_cache[107] = _createElementVNode("li", null, " Use the \"Change image opacity\" slider to change the tranparency of the overlaid. ", -1)),
                                                _cache[108] || (_cache[108] = _createElementVNode("li", null, " Choose whether to display constellations or the arrow pointing to the supernova. ", -1)),
                                                _cache[109] || (_cache[109] = _createElementVNode("li", null, " Re-center the view on the Pinwheel Galaxy's location \"now\" or Play the supernova images, in order, over time ", -1))
                                              ]),
                                              _cache[111] || (_cache[111] = _createElementVNode("br", null, null, -1)),
                                              _cache[112] || (_cache[112] = _createTextVNode(" This Data Story is powered by WorldWide Telescope (WWT). "))
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _cache[113] || (_cache[113] = _createElementVNode("div", { class: "credits" }, [
                                              _createElementVNode("h3", null, "Credits:"),
                                              _createElementVNode("h4", null, [
                                                _createElementVNode("a", {
                                                  href: "https://www.cosmicds.cfa.harvard.edu/",
                                                  target: "_blank",
                                                  rel: "noopener noreferrer"
                                                }, "CosmicDS"),
                                                _createTextVNode(" Team:")
                                              ]),
                                              _createTextVNode(" John Lewis"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Jon Carifio"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Pat Udomprasert"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Alyssa Goodman"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Mary Dussault"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Harry Houghton"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Anna Nolin"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Evaluator: Sue Sunbury"),
                                              _createElementVNode("br"),
                                              _createElementVNode("br"),
                                              _createElementVNode("h4", null, "WorldWide Telescope Team:"),
                                              _createTextVNode(" Peter Williams"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" A. David Weigel"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Jon Carifio"),
                                              _createElementVNode("br")
                                            ], -1)),
                                            _createVNode(_component_v_spacer, { class: "end-spacer" })
                                          ]),
                                          _: 1,
                                          __: [113]
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style", "modelValue"]),
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_expand_transition, null, {
              default: _withCtx(() => [
                (_ctx.showRating)
                  ? (_openBlock(), _createBlock(_component_user_experience, {
                      key: 0,
                      question: _ctx.question,
                      "icon-size": "3x",
                      onDismiss: _cache[25] || (_cache[25] = (_rating, _comments) => {
            _ctx.showRating = false;
          }),
                      onRating: _cache[26] || (_cache[26] = (rating) => {
            _ctx.currentRating = rating;
            _ctx.updateUserExperienceInfo(_ctx.currentRating, _ctx.currentComments);
          }),
                      onFinish: _cache[27] || (_cache[27] = (rating, comments) => {
            _ctx.currentRating = rating;
            _ctx.currentComments = comments;
            _ctx.updateUserExperienceInfo(_ctx.currentRating, _ctx.currentComments);
            _ctx.showRating = false;
          })
                    }, {
                      footer: _withCtx(() => [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_v_btn, {
                            class: "rating-opt-put",
                            color: "#BDBDBD",
                            size: "small",
                            variant: "text",
                            onClick: _ctx.onOptOutClicked
                          }, {
                            default: _withCtx(() => _cache[114] || (_cache[114] = [
                              _createTextVNode(" Don't show again ")
                            ])),
                            _: 1,
                            __: [114]
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_btn, {
                            class: "privacy-button",
                            color: "#BDBDBD",
                            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.showPrivacyPolicy = true)),
                            onKeyup: _cache[24] || (_cache[24] = _withKeys(($event: any) => (_ctx.showPrivacyPolicy = true), ["enter"])),
                            size: "small",
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }, {
                            default: _withCtx(() => _cache[115] || (_cache[115] = [
                              _createTextVNode(" What is this? ")
                            ])),
                            _: 1,
                            __: [115]
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["question"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_cds_privacy_policy, {
              modelValue: _ctx.showPrivacyPolicy,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.showPrivacyPolicy) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_notifications, {
          group: "startup-location",
          position: "top right"
        })
      ])
    ]),
    _: 1
  }, 8, ["style"]))
}